import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  PrelemSettingBox: {
    padding: "10px 15px",
  },
}));
